var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c("div", { staticClass: "content" }, [
        _c("h2", [_vm._v("店铺申请")]),
        _c("h3", [_vm._v("数据筛选")]),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "searchForm",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  size: "small",
                  "label-width": "110px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "申请平台", prop: "brandId" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择申请平台",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.platformId,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "platformId", $$v)
                          },
                          expression: "searchForm.platformId",
                        },
                      },
                      _vm._l(_vm.platformList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "用户ID", prop: "name" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入用户ID", clearable: "" },
                      model: {
                        value: _vm.searchForm.uid,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "uid", $$v)
                        },
                        expression: "searchForm.uid",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "用户昵称", prop: "goodsNo" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入用户昵称" },
                      model: {
                        value: _vm.searchForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "name", $$v)
                        },
                        expression: "searchForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "申请时间", prop: "brandId" } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "215px" },
                      attrs: {
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "default-time": ["00:00:00", "23:59:59"],
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                      },
                      model: {
                        value: _vm.applyTime,
                        callback: function ($$v) {
                          _vm.applyTime = $$v
                        },
                        expression: "applyTime",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { staticStyle: { "padding-bottom": "10px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("search")
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("reset")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "content" }, [
        _vm._m(0),
        _c(
          "div",
          { attrs: { id: "base-list" } },
          [
            _c("lb-table", {
              directives: [
                {
                  name: "horizontal-scroll",
                  rawName: "v-horizontal-scroll",
                  value: "always",
                  expression: "'always'",
                },
              ],
              attrs: {
                column: _vm.columns,
                data: _vm.list,
                pagination: "",
                total: _vm.page.totalNum,
                layout: "total, sizes, prev, pager, next, jumper",
                "page-sizes": [5, 10, 20, 30, 50],
                "current-page": _vm.searchForm.pageNo,
                "page-size": _vm.searchForm.pageSize,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.searchForm, "pageNo", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.searchForm, "pageNo", $event)
                },
                "selection-change": _vm.onMultipleSelection,
                "size-change": _vm.handleSizeChange,
                "p-current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [_c("h3", [_vm._v("列表数据")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }